export const DEVIATIONS = 'Deviations';
export const DEVIATIONS_PER_PATIENT = 'Deviations per patient';

export const DEVIATION = 'Deviation';
export const TRIAL_MEDIAN = 'Trial median';
